/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdminUserFleets,
  DestroyUserParams,
  SchemaValidationErrorResponse,
  StandardError,
  User,
  UserFleetsParams,
  UserInput,
  UserOptions,
  UserOptionsParams,
  Users,
  UsersParams,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Users list
 */
export const users = (
    params?: MaybeRefOrGetter<UsersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Users>(
      {url: `/users`, method: 'GET',
        params, signal
    },
      );
    }




export const getUsersQueryKey = (params?: MaybeRefOrGetter<UsersParams>,) => {
    return [
    'users', ...(params ? [params] : [])
    ] as const;
    }


export const getUsersQueryOptions = <TData = Awaited<ReturnType<typeof users>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<UsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof users>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof users>>> = ({ signal }) => users(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof users>>, TError, TData>
}

export type UsersQueryResult = NonNullable<Awaited<ReturnType<typeof users>>>
export type UsersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Users list
 */

export function useUsers<TData = Awaited<ReturnType<typeof users>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<UsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof users>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary User Options
 */
export const userOptions = (
    params?: MaybeRefOrGetter<UserOptionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<UserOptions>(
      {url: `/users/options`, method: 'GET',
        params, signal
    },
      );
    }




export const getUserOptionsQueryKey = (params?: MaybeRefOrGetter<UserOptionsParams>,) => {
    return [
    'users','options', ...(params ? [params] : [])
    ] as const;
    }


export const getUserOptionsQueryOptions = <TData = Awaited<ReturnType<typeof userOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<UserOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getUserOptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userOptions>>> = ({ signal }) => userOptions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userOptions>>, TError, TData>
}

export type UserOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof userOptions>>>
export type UserOptionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary User Options
 */

export function useUserOptions<TData = Awaited<ReturnType<typeof userOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<UserOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy User
 */
export const destroyUser = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<DestroyUserParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<User>(
      {url: `/users/${id}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDestroyUserMutationKey = () => ['destroyUser'] as const;

export const getDestroyUserMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyUser>>, TError,DestroyUserMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyUser>>, TError,DestroyUserMutationVariables, TContext> => {

const mutationKey = getDestroyUserMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyUser>>, DestroyUserMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  destroyUser(id,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyUserMutationResult = NonNullable<Awaited<ReturnType<typeof destroyUser>>>

    export type DestroyUserMutationError = ErrorType<ValidationError | StandardError>
    export type DestroyUserMutationVariables = {id: string;params?: DestroyUserParams}

    /**
 * @summary Destroy User
 */
export const useDestroyUser = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyUser>>, TError,DestroyUserMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyUser>>,
        TError,
        DestroyUserMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyUserMutationOptions(options), queryClient);
    }
    /**
 * @summary User Detail
 */
export const user = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<User>(
      {url: `/users/${id}`, method: 'GET', signal
    },
      );
    }




export const getUserQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'users',id
    ] as const;
    }


export const getUserQueryOptions = <TData = Awaited<ReturnType<typeof user>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof user>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof user>>> = ({ signal }) => user(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof user>>, TError, TData>
}

export type UserQueryResult = NonNullable<Awaited<ReturnType<typeof user>>>
export type UserQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary User Detail
 */

export function useUser<TData = Awaited<ReturnType<typeof user>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof user>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update User
 */
export const updateUser = (
    id: MaybeRefOrGetter<string>,
    userInput: MaybeRefOrGetter<UserInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
userInput = toValue(userInput);

      return axiosClient<User>(
      {url: `/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userInput, signal
    },
      );
    }




export const getUpdateUserMutationKey = () => ['updateUser'] as const;

export const getUpdateUserMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext> => {

const mutationKey = getUpdateUserMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, UpdateUserMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UserInput
    export type UpdateUserMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateUserMutationVariables = {id: string;data: UserInput}

    /**
 * @summary Update User
 */
export const useUpdateUser = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        UpdateUserMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Login as User
 */
export const loginAsUser = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/users/${id}/login-as`, method: 'GET', signal
    },
      );
    }




export const getLoginAsUserQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'users',id,'login-as'
    ] as const;
    }


export const getLoginAsUserQueryOptions = <TData = Awaited<ReturnType<typeof loginAsUser>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginAsUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLoginAsUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof loginAsUser>>> = ({ signal }) => loginAsUser(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loginAsUser>>, TError, TData>
}

export type LoginAsUserQueryResult = NonNullable<Awaited<ReturnType<typeof loginAsUser>>>
export type LoginAsUserQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Login as User
 */

export function useLoginAsUser<TData = Awaited<ReturnType<typeof loginAsUser>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginAsUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginAsUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Resend Confirmation
 */
export const resendUserConfirmation = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/users/${id}/resend-confirmation`, method: 'POST', signal
    },
      );
    }




export const getResendUserConfirmationMutationKey = () => ['resendUserConfirmation'] as const;

export const getResendUserConfirmationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendUserConfirmation>>, TError,ResendUserConfirmationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resendUserConfirmation>>, TError,ResendUserConfirmationMutationVariables, TContext> => {

const mutationKey = getResendUserConfirmationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendUserConfirmation>>, ResendUserConfirmationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  resendUserConfirmation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendUserConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof resendUserConfirmation>>>

    export type ResendUserConfirmationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ResendUserConfirmationMutationVariables = {id: string}

    /**
 * @summary Resend Confirmation
 */
export const useResendUserConfirmation = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendUserConfirmation>>, TError,ResendUserConfirmationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resendUserConfirmation>>,
        TError,
        ResendUserConfirmationMutationVariables,
        TContext
      > => {
      return useMutation(getResendUserConfirmationMutationOptions(options), queryClient);
    }
    /**
 * @summary Send Password Reset
 */
export const sendUserPasswordReset = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/users/${id}/send-password-reset`, method: 'POST', signal
    },
      );
    }




export const getSendUserPasswordResetMutationKey = () => ['sendUserPasswordReset'] as const;

export const getSendUserPasswordResetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendUserPasswordReset>>, TError,SendUserPasswordResetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendUserPasswordReset>>, TError,SendUserPasswordResetMutationVariables, TContext> => {

const mutationKey = getSendUserPasswordResetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendUserPasswordReset>>, SendUserPasswordResetMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  sendUserPasswordReset(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendUserPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof sendUserPasswordReset>>>

    export type SendUserPasswordResetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SendUserPasswordResetMutationVariables = {id: string}

    /**
 * @summary Send Password Reset
 */
export const useSendUserPasswordReset = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendUserPasswordReset>>, TError,SendUserPasswordResetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendUserPasswordReset>>,
        TError,
        SendUserPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getSendUserPasswordResetMutationOptions(options), queryClient);
    }
    /**
 * @summary User Fleets list
 */
export const userFleets = (
    userId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserFleetsParams>,
 signal?: AbortSignal
) => {
      userId = toValue(userId);
params = toValue(params);

      return axiosClient<AdminUserFleets>(
      {url: `/users/${userId}/fleets`, method: 'GET',
        params, signal
    },
      );
    }




export const getUserFleetsQueryKey = (userId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserFleetsParams>,) => {
    return [
    'users',userId,'fleets', ...(params ? [params] : [])
    ] as const;
    }


export const getUserFleetsQueryOptions = <TData = Awaited<ReturnType<typeof userFleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(userId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserFleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userFleets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getUserFleetsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userFleets>>> = ({ signal }) => userFleets(userId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userFleets>>, TError, TData>
}

export type UserFleetsQueryResult = NonNullable<Awaited<ReturnType<typeof userFleets>>>
export type UserFleetsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary User Fleets list
 */

export function useUserFleets<TData = Awaited<ReturnType<typeof userFleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 userId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserFleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userFleets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserFleetsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






